import styles from "./Category.module.css";
import Card from "./Card";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function Category() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const params = useParams();
  useEffect(() => {
    const getCategory = async () => {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/categories/${params.name}`,
        method: "GET",
      });
      setProducts(response.data.products);
      setCategory(response.data.name);
    };
    getCategory();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [params.name]);

  return (
    <>
      <section className="bg-black">
        <div className="position-relative">
          <div className={styles.category_image_desktop}></div>
          <div className={styles.category_image_mobile}></div>
          <div className={styles.transition}></div>
        </div>

        <div className={styles.product + " container ps-0 pe-0"}>
          <h1 className={styles.category_name}>{category}</h1>
          <div
            className={
              styles.category_row + " row d-flex justify-content-center"
            }
          >
            {products.map((product) => {
              return <Card key={product._id} product={product} />;
            })}
          </div>
        </div>
      </section>
    </>
  );
}
export default Category;
